import { brazilianStates } from '@common';
import { InputMask } from '@components/atoms';
import { Checkbox, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { useEffect } from 'react';

interface FormAddressProps {
	showCopy?: boolean;
	onChangeCep?: (cep: any) => void;
	defaultMemberAddress: boolean;
}

const apiCep = axios.create({
	baseURL: 'https://viacep.com.br/ws/',
});

export const FormAddress = ({ showCopy, onChangeCep, defaultMemberAddress }: FormAddressProps) => {
	const isSpouseAddress = Form.useWatch('isSpouseAddress');

	useEffect(() => {
		if (isSpouseAddress && !defaultMemberAddress) {
			message.error('To continue, the address must first be saved on the previous tab.');
		}
	}, [isSpouseAddress, defaultMemberAddress]);

	const handleChangeCep = (cep: string) => {
		const value = cep.replace(/\D/g, '');

		if (value.length === 8) {
			apiCep
				.get<any>(`${value}/json`)
				.then((res) => onChangeCep?.(res.data));
		}
	};

	return (
		<div className='space-y-6'>
			{showCopy && (
				<Form.Item name='isSpouseAddress' valuePropName='checked'>
					<Checkbox>Use the spouse's information</Checkbox>
				</Form.Item>
			)}

			{!isSpouseAddress && (
				<>
					<Form.Item label='CEP' name='cep' >
						<InputMask
							mask='cep'
							onChange={(e) => handleChangeCep(e.target.value)}
						/>
					</Form.Item>

					<Form.Item label='Street' name='street'>
						<Input />
					</Form.Item>

					<div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
						<Form.Item label='Number' name='number'>
							<Input placeholder='Enter the number' />
						</Form.Item>

						<Form.Item label='Apt / Suite' name='complement'>
							<Input placeholder='Enter the apt / suite' />
						</Form.Item>

						<Form.Item label='Neighborhood' name='neighborhood'>
							<Input placeholder='Enter the neighborhood' />
						</Form.Item>
					</div>

					<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
						<Form.Item label='City' name='city'>
							<Input />
						</Form.Item>

						<Form.Item label='State' name='state' rules={[{ required: true }]}>
							<Select
								showSearch
								optionFilterProp='label'
								options={brazilianStates}
							/>
						</Form.Item>
					</div>
				</>
			)}
		</div>
	);
};
